export default {
  recommendedShopsTitle: {
    gb: 'Browse More Items From Top Shops',
    default: 'Browse Top Shops',
  },
};
